// extracted by mini-css-extract-plugin
export var spin = "newsletter-section-title-module--spin--be084";
export var title = "newsletter-section-title-module--title--67c7d";
export var title__black = "newsletter-section-title-module--title__black--6945a";
export var title__bloodorange = "newsletter-section-title-module--title__bloodorange--5ff15";
export var title__chartruse = "newsletter-section-title-module--title__chartruse--62abc";
export var title__cobalt = "newsletter-section-title-module--title__cobalt--29e58";
export var title__emerald = "newsletter-section-title-module--title__emerald--1f306";
export var title__paper = "newsletter-section-title-module--title__paper--0b2c4";
export var title__pink = "newsletter-section-title-module--title__pink--f8ef3";
export var title__sky = "newsletter-section-title-module--title__sky--1a40f";
export var title__white = "newsletter-section-title-module--title__white--18bdf";
export var wrapper = "newsletter-section-title-module--wrapper--ba80a";